/**
 * Created by renjie.huang on 2018/3/20.
 */
import config from '../config/config';

function getRootDomain(url) {
    return url.slice(url.indexOf('.'));
}

function getCookie(name)
{
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg)){
        try{
            return decodeURIComponent(arr[2])
        }catch(e) {
            return null;
        }
    }
    return null;
}

function setCookie(name, value, isExpire, days)
{
    var expiresTime = isExpire ? new Date(new Date().getTime() - 86400) : new Date(new Date().getTime() + 86400000000); //cookie有限期（24*60*60*1000*1000）
    var host = window.location.host;
    let domain = config.root;

    if (days) {
        expiresTime = new Date();
        expiresTime.setTime(expiresTime.getTime() + days * 24 * 60 * 60 * 1000); // 计算 1 天后的时间
    }

    if(host.indexOf('passport.ucloud.cn') < 0 && config.root === 'ucloud.cn'){
        // 为了避免 根域名 为 ucloud.cn 的情况下，覆盖公有云的 cookie
        // （目前只有教育云还在线）
        // domain 为空时，cookie 会被设置到当前域名下
        domain = '' 
    }

    if(host.indexOf('localhost')>=0){
        domain = 'localhost'
    }
    // 在设置新的cookie前，清空 host 的老 cookie，避免脏数据
    window.document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    window.document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.' + host + '; path=/;';


    window.document.cookie = `${name}=${value};domain=${domain};Path=/;expires=${expiresTime};`
}
function getCSRFToken(){
    return getCookie('CSRF_TOKEN');
}
function getUCSRFToken(){
    return getCookie('U_CSRF_TOKEN');
}

module.exports = {
    getCookie : getCookie,
    setCookie : setCookie,
    getCSRFToken,
    getUCSRFToken
}



// WEBPACK FOOTER //
// ./src/common/cookie.js